import axios from 'axios' 
import {ResponseHelper} from '../../../../setup/index'
import {API_URL} from '../../../../setup/helpers/apiUrl'



export const GET_PRODUCT_LIST = `${API_URL}/api/CallCenter/GetMetroProductFromService`
export const GET_PRODUCT_DETAIL = `${API_URL}/api/CallCenter/GetMetroProductDetailFromService`

export async  function GetProductList(storeNumber:number,productReference:string,currentPageNumber:number){ 
      let resp;
      try{
         await axios.get<ResponseHelper>(GET_PRODUCT_LIST +"?storeNumber="+storeNumber+"&productReference=" + productReference+"&currentPageNumber="+currentPageNumber+"&Target=CallCenter_Product&Api=GetProductList&UserSetting=CallCenterProductUser")
          .then((response) =>{
              console.log("then =>", response);
              resp = response;  
          })
          .catch((err) => {
            console.log("thenCatch =>", err);
            if(err.response.status === 401){
              document.location.reload();
            }
          });
          return resp;
        } 
        catch(err){
          console.log("login error =>", err);
          console.log("catch resp =>", resp);
          return err;
        }
  }

  
export async  function GetProductDetail(storeNumber:number,subsystemNo:number){ 
  let resp;
  try{
     await axios.get<ResponseHelper>(GET_PRODUCT_DETAIL +"?storeNumber="+storeNumber+"&subsystemNo=" + subsystemNo+"&Target=CallCenter_Product&Api=GetProductDetail&UserSetting=CallCenterProductUser")
      .then((response) =>{
          console.log("then =>", response);
          resp = response;  
      })
      .catch((err) => {
        console.log("thenCatch =>", err);
        if(err.response.status === 401){
          document.location.reload();
        }
      });
      return resp;
    } 
    catch(err){
      console.log("login error =>", err);
      console.log("catch resp =>", resp);
      return err;
    }
}